<template>
    <el-container>
        <div class="empty-page">
            <img src="../assets/images/empty.png" alt="">
            <span>网站建设中，敬请期待...</span>
        </div>
        <!-- <el-header height="88px">
            <HeaderNav :curHash="'home'" @updateLang='updateLang' />
        </el-header>
        <el-main :style="`height: ${contentHeight}px; flex-grow:1`">
            <div class="torvandom-banner">
                <el-carousel height="370px">
                    <el-carousel-item v-for="(item, index) in carouselUrl" :key="index">
                        <img :src="item.url" alt="">
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="torvandom-body" ref="torvandom-body" :style="`height:${contentHeight-370}px`">
                <el-row :gutter="100">
                    <el-col :span="6">
                        <el-card class="box-card-left">
                            <div slot="header" class="clearfix card-header">
                                <span class="card-type">{{$t('productTitle')}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text">{{$t('more')}}</el-button>
                            </div>
                            <div v-for="(item, index) in productList" :key="index" class="item-repeat">
                                <span class="type">{{item.type }}</span>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="10">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="card-type">{{$t('newsTitle')}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text">{{$t('more')}}</el-button>
                            </div>
                            <div>
                                <ul class="torvandom-news">
                                    <li v-for="(item, index) in newsContext" :key="index">{{item}}</li>
                                </ul>
                            </div>
                        </el-card>
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="card-type">{{$t('caseTitle')}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text">{{$t('more')}}</el-button>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="8">
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="card-type">{{$t('introduction')}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text">{{$t('more')}}</el-button>
                            </div>
                            <div class="introduction-content">
                               {{$t('intDes')}}
                            </div>
                        </el-card>
                        <el-card class="box-card">
                            <div slot="header" class="clearfix card-header">
                                <span class="card-type">{{$t('contact')}}</span>
                                <el-button style="float: right; padding: 3px 0" type="text">{{$t('more')}}</el-button>
                            </div>
                            <div class="contact-content">
                                <p class="company">{{$t('company')}}</p>
                                <p class="address">{{$t('address')}}</p>
                                <p class="call">{{$t('phone')}}</p>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </div>
        </el-main>
        <el-footer height="54px">
            <Footer ref="foot-ref"/>
        </el-footer> -->
    </el-container>
</template>

<script>
import HeaderNav from '../components/header.vue'
import Footer from '../components/footer.vue'
import { getProductList, getNewsList } from '../../static/data.js'
export default {
  name: 'Index',
  components: { HeaderNav, Footer },
  data () {
    return {
      contentHeight: 0,
      carouselUrl: [
          { url: require('../assets/images/1.jpg') },
          { url: require('../assets/images/2.jpg') },
          { url: require('../assets/images/3.jpg') },
          { url: require('../assets/images/4.jpg') },
          { url: require('../assets/images/5.jpg') }
      ],
      newsContext: [],
      lang: '',
      productList: []
    }
  },
  methods: {
      updateLang (val) {
          this.lang = val
      },
      getContextByLang (lang) {
          this.productList = getProductList(lang)
          this.newsContext = getNewsList(lang)
          this.$refs['foot-ref'].switchLang(lang)
      }
  },
  watch: {
      'lang' (val, old) {
          if (val && old) {
            this.getContextByLang(val)
          }
      }
  },
  mounted () {
      this.lang = this._i18n._vm.locale
      this.getContextByLang(this.lang)
      this.$nextTick(() => {
          this.contentHeight = document.documentElement.clientHeight - 54 - 88
      })
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/common.less";
.el-carousel__item{
    img{
        width: 100%;
        height: 370px;
    }
}
.empty-page{
    width: 50%;
    margin: 100px auto;
    span{
        font-size: 24px;
        color: #666
    }
    img{
        display: inline-block;
        width: 100%
    }
}
    .torvandom-body{
        // height: 100%;
        width: 92%;
        margin: auto;
        .el-row {
            height: 100%;
            .el-col{
                position: relative;
                &::after{
                    position: absolute;
                    clear: both;
                    content: '';
                    right: 0;
                    top: 64px;
                    bottom: 0;
                    border-right: 1px dashed #e0d7d7
                }
                &:last-child{
                     &::after{
                         display: none;
                     }
                }
            }
            &:last-child {
                margin-bottom: 0;
            }
            .el-card{
                box-shadow: none;
                border: none;
                min-height: 50%;
                .el-card__body{
                    padding: 20px 0;
                }
                .card-header{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    .card-type{
                        flex: 1;
                        text-align: left;
                        font-size: 18px;
                        font-weight: 500;
                    }
                }
                .introduction-content{
                    text-align: justify;
                    line-height: 1.5;
                    text-indent: 34px;
                    font-family: '-webkit-pictograph';
                }
                .contact-content{
                    p{
                        text-align: left;
                        line-height: 1.5;
                        &.company{
                            font-size: 16px;
                            color: #111;
                            font-weight: 500;
                            margin-bottom: 10px;
                        }
                        &.address{
                            margin-bottom: 10px;
                        }
                    }

                }

                .item-repeat{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    height: 24px;
                    margin-bottom: 6px;
                    font-family: '-webkit-pictograph';
                    span{
                        flex: 1;
                        font-family: '-webkit-pictograph';
                        &.series{
                            text-align: left;
                            color: #555;
                        }
                        &.type{
                            text-align: left;
                            color: #111;
                        }
                    }
                }
            }
            .box-card-left, .el-col{
                height: 100%;
            }
            ul.torvandom-news{
                li{
                    text-align: left;
                    position: relative;
                    padding-left: 10px;
                    line-height: 32px;
                    font-family: '-webkit-pictograph';
                    &::before{
                        position: absolute;
                        content: '';
                        clear: both;
                        left: 0;
                        height: 1px;
                        width: 4px;
                        border-bottom: 1px solid #222;
                        top: 50%;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue